import { ExclamationCircleOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Input,
  message,
  Modal,
  Row,
  Table,
  Select,
  Spin,
  Typography,
} from "antd";
import moment from "moment";
import { Component } from "react";
import "../Common.global.css";
const { Text } = Typography;
const { confirm } = Modal;

const flexColumnOverflow = {
  display: "flex",
  flex: "auto",
  flexDirection: "column",
  overflowY: "scroll",
};
const flexColumn = {
  display: "flex",
  flex: "auto",
  flexDirection: "column",
};
const columns = [
  {
    title: "Name",
    dataIndex: "display_name",
    align: "center",
    ellipsis: true,
    sorter: (a, b) => a.display_name.localeCompare(b.display_name),
  },
  {
    title: "Start (Minutes)",
    dataIndex: "range_min_start",
    align: "center",
    ellipsis: true,
  },
  {
    title: "End (Minutes)",
    dataIndex: "range_min_end",
    align: "center",
    ellipsis: true,
  },
  {
    title: "Amount (RIEL)",
    dataIndex: "amount",
    align: "center",
    ellipsis: true,
  },
  {
    title: "Repeat Interval",
    dataIndex: "repeat_interval",
    align: "center",
    ellipsis: true,
  },
  {
    title: "Type",
    dataIndex: "rate_apply_type_display_name",
    align: "center",
    ellipsis: true,
  },
  {
    title: "Date Created",
    dataIndex: "inserted_at",
    align: "center",
    ellipsis: true,
    render: (updated_at) => {
      return <>{moment(updated_at).format("DD/MM/YYYY HH:mm")}</>;
    },
    sorter: (a, b) =>
      moment(a.inserted_at).unix() - moment(b.inserted_at).unix(),
  },
];

export default class Car extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRowKeys: [],
      rates: [],
      newTicketRateModalVisible: false,
      selectedRateApplyTypeId: null,
      selectedRateApplyRefCode: null,
      rateApplyTypes: [],
      rateName: null,
      rangeStart: null,
      rangeEnd: null,
      amount: null,
      repeatInterval: null,
      isLoading: false,
    };
  }

  componentDidMount() {
    this.setState({
      isInitialLoading: true,
    });
    return this.refreshList();
  }

  refreshList = () => {
    this.setState({ isLoading: true });
    return fetch(`/api/v1/rate/car/list`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        token: this.props.accessToken,
      },
    })
      .then((res) => {
        if (!res.ok) {
          return res
            .json()
            .catch(() => {
              // Couldn't parse the JSON
              throw new Error(res.statusText);
            })

            .then(({ error }) => {
              // Got valid JSON with error response, use it
              throw new Error(error || res.statusText);
            });
        }
        return res.json();
      })
      .then((data) => {
        const { rates, rateApplyTypes } = data;
        this.setState({
          rates: rates || [],
          rateApplyTypes: rateApplyTypes || [],
        });
      })
      .catch((err) => {
        message.error(
          err instanceof Error ? err.message : "Server cannot be reached"
        );
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };

  onDeleteClick = () => {
    const { selectedRowKeys } = this.state;
    const requestData = {
      id: selectedRowKeys[0],
    };
    const _this = this;
    confirm({
      title: "Please confirm",
      icon: <ExclamationCircleOutlined />,
      content: "Are you sure you would like to delete the selected rate?",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        return fetch(`/api/v1/rate/car/delete`, {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            token: _this.props.accessToken,
          },
          body: JSON.stringify(requestData),
        })
          .then((res) => {
            if (!res.ok) {
              throw new Error(res.statusText);
            }
            return res.json();
          })
          .then(() => {
            message.success("Delete Completed!");
            _this.setState({ selectedRowKeys: [] });
            _this.refreshList();
          })
          .catch(() => {
            message.error("Error deleting rate!");
          });
      },
    });
  };

  onSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };

  onCreateTicketRateCancel = () => {
    this.setState({
      newTicketRateModalVisible: false,
    });
  };

  onCreateTicketRateOk = () => {
    const {
      rateName,
      selectedRateApplyTypeId,
      selectedRateApplyRefCode,
      rangeStart,
      rangeEnd,
      amount,
      repeatInterval,
    } = this.state;
    return fetch(`/api/v1/rate/car/new`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        token: this.props.accessToken,
      },
      body: JSON.stringify({
        rateName,
        selectedRateApplyTypeId,
        selectedRateApplyRefCode,
        rangeStart,
        rangeEnd,
        amount,
        repeatInterval,
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
      })
      .then(() => {
        this.setState({
          newTicketRateModalVisible: false,
        });
        this.refreshList();
        return message.success("Rate Created Successfully!");
      })
      .catch(() => {
        message.error("Error creating rate!");
      });
  };

  onAddClick = () => {
    this.setState({
      newTicketRateModalVisible: true,
      rateName: null,
      selectedRateApplyTypeId: null,
      selectedRateApplyRefCode: null,
      rangeStart: null,
      rangeEnd: null,
      amount: null,
      repeatInterval: null,
    });
  };

  render() {
    const {
      selectedRowKeys,
      rates,
      newTicketRateModalVisible,
      rateApplyTypes,
      rateName,
      selectedRateApplyTypeId,
      selectedRateApplyRefCode,
      rangeStart,
      rangeEnd,
      amount,
      repeatInterval,
      isLoading,
    } = this.state;
    const rowSelection = {
      type: "radio",
      selectedRowKeys,
      onChange: this.onSelectChange,
    };

    return (
      <div className="site-feature-container">
        <div className="page-header-container">
          <div>
            <div className="page-header-main">Rate</div>
            <div className="page-header-sub">Car</div>
          </div>
        </div>
        <Card bodyStyle={flexColumn} style={flexColumnOverflow}>
          <Spin tip="Please Wait..." spinning={isLoading}>
            <Row>
              <div className="setting-section-search">
                <Row
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Col
                    className="setting-detail-group"
                    style={{ padding: "0px" }}
                  >
                    <Button
                      key="Add"
                      className="setting-section-search-btn"
                      type="primary"
                      onClick={this.onAddClick}
                    >
                      Add
                    </Button>
                    <Button
                      key="Delete"
                      className="setting-section-search-btn"
                      danger
                      onClick={this.onDeleteClick}
                      disabled={selectedRowKeys.length === 0}
                    >
                      Delete
                    </Button>
                  </Col>
                </Row>
              </div>
            </Row>
            <Row>
              <div className="table-section-header">Car Rates</div>
              <Table
                rowKey="id"
                style={{ overflow: "auto", width: "100%" }}
                rowSelection={rowSelection}
                columns={columns}
                dataSource={rates}
                size="small"
                scroll={{ x: 800 }}
              />
            </Row>
          </Spin>
        </Card>
        <Modal
          title="Add Car Rate"
          closable={false}
          visible={newTicketRateModalVisible}
          onOk={this.onCreateTicketRateOk}
          onCancel={this.onCreateTicketRateCancel}
          okButtonProps={{
            disabled:
              isLoading ||
              !rateName ||
              !selectedRateApplyTypeId ||
              !amount ||
              ((selectedRateApplyRefCode === "FIXED" ||
                selectedRateApplyRefCode === "REPEAT") &&
                !rangeStart) ||
              (selectedRateApplyRefCode === "FIXED" && !rangeEnd) ||
              (selectedRateApplyRefCode === "REPEAT" && !repeatInterval),
          }}
          cancelButtonProps={{ disabled: isLoading }}
        >
          <Row>
            <Col span={24} className="visitor-detail-group">
              <Col>
                <Text type="secondary">Rate Type Process Order :</Text>
              </Col>
              <Col>
                <Text type="secondary">1. Fixed = Fixed Rate for Range</Text>
              </Col>
              <Col>
                <Text type="secondary">
                  2. Repeat = Repeat every X minutes from start minutes
                </Text>
              </Col>
              <Col>
                <Text type="secondary">
                  3. Nightly (Penalty) = Fixed overnight penalty after midnight.
                </Text>
              </Col>
              <Col style={{ marginBottom: "10px" }}>
                <Text type="secondary">
                  4. Nightly (Repeat) = Overnight repeat rate. Overrides fixed
                  and repeat rates after midnight.
                </Text>
              </Col>
              <Col style={{ marginBottom: "10px" }}>
                <Text type="secondary">
                  (Range_Start &le; Time &lt; Range_End)
                </Text>
              </Col>
              <Input.Group
                compact
                className="group-compact-select-wrapper"
                style={{ marginBottom: "10px" }}
              >
                <span className="ant-input-group-addon group-addon-label">
                  Name <span style={{ color: "red" }}>*</span>
                </span>
                <Input
                  value={rateName}
                  onChange={(e) => {
                    this.setState({
                      rateName: e.target.value,
                    });
                  }}
                />
              </Input.Group>
              <Input.Group
                compact
                className="group-compact-select-wrapper"
                style={{ marginBottom: "10px" }}
              >
                <span className="ant-input-group-addon group-addon-label">
                  Type <span style={{ color: "red" }}>*</span>
                </span>
                <Select
                  className="group-addon-input"
                  value={selectedRateApplyTypeId}
                  onChange={(val, selectedData) => {
                    const { rangeStart, rangeEnd } = this.state;
                    const selectedRateApplyRefCode = selectedData.refcode;
                    this.setState({
                      selectedRateApplyTypeId: val,
                      selectedRateApplyRefCode: selectedData.refcode,
                      repeatInterval: null,
                      rangeStart: !(
                        selectedRateApplyRefCode === "FIXED" ||
                        selectedRateApplyRefCode === "REPEAT"
                      )
                        ? null
                        : rangeStart,
                      rangeEnd: !(selectedRateApplyRefCode === "FIXED")
                        ? null
                        : rangeEnd,
                    });
                  }}
                >
                  {rateApplyTypes.map((rateApplyType) => (
                    <Select.Option
                      value={rateApplyType.id}
                      key={rateApplyType.id}
                      refcode={rateApplyType.ref_code}
                    >
                      {rateApplyType.display_name}
                    </Select.Option>
                  ))}
                </Select>
              </Input.Group>

              <Input.Group
                compact
                className="group-compact-select-wrapper"
                style={{ marginBottom: "10px" }}
              >
                <span className="ant-input-group-addon group-addon-label">
                  Range Start (Minutes) <span style={{ color: "red" }}>*</span>
                </span>
                <Input
                  type="number"
                  name="rangeStart"
                  disabled={
                    !selectedRateApplyTypeId ||
                    !(
                      selectedRateApplyRefCode === "FIXED" ||
                      selectedRateApplyRefCode === "REPEAT"
                    )
                  }
                  value={rangeStart}
                  onBlur={() => {
                    const { rangeStart, rangeEnd } = this.state;
                    this.setState({
                      rangeEnd:
                        parseInt(rangeStart) > parseInt(rangeEnd)
                          ? null
                          : rangeEnd,
                    });
                  }}
                  onChange={(e) => {
                    const { name, value } = e.target;
                    this.setState({
                      [name]: value,
                    });
                  }}
                />
              </Input.Group>
              <Input.Group
                compact
                className="group-compact-select-wrapper"
                style={{ marginBottom: "10px" }}
              >
                <span className="ant-input-group-addon group-addon-label">
                  Range End (Minutes) <span style={{ color: "red" }}>*</span>
                </span>
                <Input
                  type="number"
                  name="rangeEnd"
                  value={rangeEnd}
                  onBlur={() => {
                    const { rangeStart, rangeEnd } = this.state;
                    this.setState({
                      rangeStart:
                        parseInt(rangeStart) > parseInt(rangeEnd)
                          ? null
                          : rangeStart,
                    });
                  }}
                  disabled={
                    !(selectedRateApplyRefCode === "FIXED") ||
                    !selectedRateApplyTypeId
                  }
                  onChange={(e) => {
                    const { name, value } = e.target;
                    this.setState({
                      [name]: value,
                    });
                  }}
                />
              </Input.Group>
              <Input.Group
                compact
                className="group-compact-select-wrapper"
                style={{ marginBottom: "10px" }}
              >
                <span className="ant-input-group-addon group-addon-label">
                  Repeat
                  <span style={{ color: "red" }}>*</span>
                </span>
                <Input
                  type="number"
                  name="repeatInterval"
                  value={repeatInterval}
                  disabled={
                    !(
                      selectedRateApplyRefCode === "REPEAT" ||
                      selectedRateApplyRefCode === "NIGHTLY_REPEAT"
                    ) || !selectedRateApplyTypeId
                  }
                  onChange={(e) => {
                    const { name, value } = e.target;
                    this.setState({
                      [name]: value,
                    });
                  }}
                />
              </Input.Group>
              <Input.Group
                compact
                className="group-compact-select-wrapper"
                style={{ marginBottom: "10px" }}
              >
                <span className="ant-input-group-addon group-addon-label">
                  Amount (RIEL)<span style={{ color: "red" }}>*</span>
                </span>
                <Input
                  type="number"
                  name="amount"
                  value={amount}
                  onChange={(e) => {
                    const { name, value } = e.target;
                    this.setState({
                      [name]: value,
                    });
                  }}
                />
              </Input.Group>
            </Col>
          </Row>
        </Modal>
      </div>
    );
  }
}
